// AI Model Constants
// These constants define which AI models to use in different parts of the application

// Main model constants
export const MODEL_KEY_REASONING_FAST = "rg-reasoning-fast";
export const MODEL_NAME_DEFAULT = "rg-chat-fast";

// Model name aliases for readability
export const MODEL_NAME_BIG_CHAT = MODEL_KEY_REASONING_FAST; // Big chat uses reasoning large model
export const MODEL_NAME_SMALL_CHAT = MODEL_NAME_DEFAULT; // Small chat uses default
export const MODEL_NAME_DOCUMENT_ASSISTANT = MODEL_NAME_DEFAULT; // Document assistant uses default
export const MODEL_NAME_POPUP_HELPER = MODEL_NAME_DEFAULT; // Popup helper uses default
